import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';
import axios from 'axios';

export const fetchAmount = async (payload) => {
    try {
        const response = await axios(
            `${getDomainOrigin()}/auto-insurance/mpos/quote/get_price`,
            {
                method: 'POST',
                data: JSON.stringify({
                    ...payload,
                }),
                ...getAxiosConfig(),
            }
        );

        return response.data;
    } catch (error) {
        return error;
    }
};

export const postData = async (payload) => {
    try {
        const response = await axios(
            `${getDomainOrigin()}/auto-insurance/mpos/quote/issue`,
            {
                method: 'POST',
                data: JSON.stringify({
                    ...payload,
                }),
                ...getAxiosConfig(),
            }
        );

        return {
            status: response?.status,
            data: response?.data,
        };
    } catch (error) {
        return error;
    }
};
